import {
  Component,
  OnInit,
  OnDestroy,
  ElementRef,
  Renderer2,
  AfterViewInit,
} from '@angular/core';
import { MDBModalRef } from 'angular-bootstrap-md';
import { Router } from '@angular/router';

@Component({
  selector: 'app-modal-home',
  templateUrl: './modal-home.component.html',
  styleUrls: ['./modal-home.component.scss'],
})
export class ModalHomeComponent implements OnInit, AfterViewInit, OnDestroy {
  noShowAgain: boolean = false;
  private readonly STORAGE_KEY = 'hideDiscountModal';
  private clickListener: () => void;

  constructor(
    public modalRef: MDBModalRef,
    private el: ElementRef,
    private renderer: Renderer2,
    private router: Router
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit() {
    // Listener opcional para cerrar al hacer clic fuera
    this.clickListener = this.renderer.listen('document', 'click', (event: MouseEvent) => {
      if (!this.el.nativeElement.contains(event.target)) {
        // this.onClosemodal();
      }
    });
  }

  ngOnDestroy(): void {
    // Limpiar el listener de clicks al destruir el componente
    if (this.clickListener) {
      this.clickListener();
    }
  }

  /**
   * Cierra el modal simple
   */
  onClosemodal() {
    sessionStorage.setItem('discountModalShownInFlow', 'true');
    this.modalRef.hide();
  }

  /**
   * Cierra el modal y guarda preferencia en localStorage si está marcado
   */
  cerrarModal() {
    if (this.noShowAgain) {
      localStorage.setItem(this.STORAGE_KEY, 'true');
    }
    sessionStorage.setItem('discountModalShownInFlow', 'true');
    this.modalRef.hide();
  }

  /**
   * Navega al catálogo de fotografías y cierra el modal
   */
  irAExplorarFotos() {
    if (this.noShowAgain) {
      localStorage.setItem(this.STORAGE_KEY, 'true');
    }
    sessionStorage.setItem('discountModalShownInFlow', 'true');
    this.modalRef.hide();
    this.router.navigate(['/fotografias']);
  }

    irAExplorarPortadas() {
    if (this.noShowAgain) {
      localStorage.setItem(this.STORAGE_KEY, 'true');
    }
    sessionStorage.setItem('discountModalShownInFlow', 'true');
    this.modalRef.hide();
    this.router.navigate(['/portadas']);
  }
}
